var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightWhite = function SvgArrowRightWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m11.724 22.093-.929-.928a.56.56 0 0 1 0-.796l7.272-7.271H2.063a.563.563 0 0 1-.563-.563v-1.312c0-.311.252-.563.563-.563h16.004l-7.272-7.272a.56.56 0 0 1 0-.795l.928-.928c.22-.22.576-.22.796 0l9.816 9.816c.22.22.22.576 0 .796l-9.816 9.816a.56.56 0 0 1-.796 0"
  })));
};
export default SvgArrowRightWhite;